import React from "react"
import Bugsnag from "@bugsnag/js"
import BugsnagPluginReact from "@bugsnag/plugin-react"
import { useAuth } from "../../contexts/auth"

setTimeout(() => { }).__proto__.unref = () => { }

if (!Bugsnag._client) {
  const ignoredErrors = [
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications.",
    "Firebase: Error (auth/network-request-failed).",
    "Firebase: Error (auth/user-token-expired).",
    "NetworkError when attempting to fetch resource.",
    "Script error.",
    "Error loading chunk",
    "ApolloError: Failed to fetch"
]

  const bugsnagKey = process.env.NEXT_PUBLIC_BUGSNAG_API_KEY

  Bugsnag.start({
    apiKey: bugsnagKey,
    appVersion: process.env.NEXT_PUBLIC_APP_VERSION ?? "unknown",
    plugins: [new BugsnagPluginReact(React)],
    enabledReleaseStages: [process.env.NEXT_PUBLIC_BUGSNAG_RELEASE_STAGE ?? ""],
    onError: event => {
      const { errors: [{ errorMessage }] } = event
      if (ignoredErrors.some(msg => errorMessage.includes(msg))) {
        return false
      }
      const { user: { displayName, email } } = useAuth()
      event.setUser(null, email, displayName)
    }
  })
}

const ErrorBoundary = Bugsnag.getPlugin("react")

export { ErrorBoundary as ErrorBoundary, Bugsnag }
